import gql from 'graphql-tag'

export default gql`mutation editCreateSchedule($data: UserScheduleInput!){
    editCreateSchedule(data: $data) @client
}`